import {DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import {useContext, useState} from "react";
import MovePayment from "../Panel/Payment/MovePayment";
import {MoneyField} from "../Utilities/MoneyField";

function PaymentList(props) {
    const [user] = useContext(AuthContext);
    const [movePayment, setMovePayment] = useState(false);
    const columns = [
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Nazwa utworzonego projektu',
            fieldName: 'value',
            minWidth: 160,
            maxWidth: 200,
            isRowHeader: true,
            isResizable: false,
            ...MoneyField()
        },
        {
            key: 'timestamp',
            name: 'Data',
            ariaLabel: 'Data przelewu',
            fieldName: 'timestamp',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => (<span>{item.timestamp.substr(0, 10)}</span>)
        },
        {
            key: 'person',
            name: 'Kontakt',
            ariaLabel: 'Kontakt odpowiedzialny za przelew',
            fieldName: 'person',
            minWidth: 150,
            maxWidth: 350,
            isResizable: true,
        },
        {
            key: 'notes',
            name: 'Opis',
            ariaLabel: 'Tytuł przelewu',
            fieldName: 'notes',
            minWidth: 200,
            isResizable: true,
        },
        {
            key: 'invoice_number',
            name: 'Faktura',
            ariaLabel: 'Faktura',
            fieldName: 'invoice_number',
            minWidth: 120,
            isResizable: true,
        },
        {
            key: 'delete',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'delete',
            minWidth: 80,
            isResizable: true,
            onRender: (item) => {
                const move = (<IconButton iconProps={{iconName: 'Move'}} title='Przenieś'
                                          onClick={() => setMovePayment({id: item.id})}/>);
                if (item.keystring === null) {
                    return (<span>{move}<IconButton iconProps={{iconName: 'trash'}} title='Usuń'
                                                    onClick={() => _delete(item.id)}/></span>);
                }
                return move;
            }
        }
    ];

    const _delete = (id) => {
        fetch(`/api/payment/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err)
            })
    }
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
            <MovePayment add={movePayment} dismissPanel={() => setMovePayment(false)} onSuccess={() => props.update(props.data.filter((item) => item.id !== movePayment.id))}/>
        </Stack.Item>);
    }
    return null;
}

PaymentList.defaultProps = {
    title: 'Wpłaty'
}

export default PaymentList;